import React, { useEffect, useState } from 'react';
import Title from '../../common/Title';
import Slider from '../../carousel/Slider';
import { addDivParam } from '../../../../common/utils/liveUtil';

export default function Tv24CurationNewAndHotType1(props) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (props.data) {
      const items = props.data.items.filter(item => item.pc_service_yn === 'Y').map(item => ({
        title: item.title,
        img: item.pc_program_img ? item.pc_program_img.replace('s3.ap-northeast-2.amazonaws.com/', '') : '',
        link_url: addDivParam(item.pc_link_url) || ''
      }));
      setData(items);
    }

  }, [props]);

  return (
    (data && <div className='contents_area_24tvType01'>
      <Title title={props.data.title} />
      <Slider type='thumb' clickParams='div=live_list' data={data} />
    </div>
    )
  );
}
